import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The Dresden Dolls Insanity",
  "description": "",
  "published": "2008-05-13T00:00:00.000Z",
  "redirect_from": ["/blog/the-dresden-dolls-insanity/swizec/113"],
  "categories": "intrigues, life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The Dresden Dolls are releasing a new album called No, Virginia. So far I've only heard one song from it, simply because youtube shoved it in my face, and it's looking awesome. Classic Dolls, all the weirdness I've come to expect and yet all the melody I enjoy.`}</p>
    <p>{`In order to help their release along they've decided to hold a special little contest for everyone who pre-orders. The winner, supposedly randomly selected, gets a toy piano and the stool to go with it. The piano was featured in a, sadly cut, scene of the Coin-Operated Boy video. Plus some other far less important stuff.`}</p>
    <p>{`Now I know there's next to no chance of me getting that piano, but I damned well wanted the CD. My first purchased CD since ... err ... 2000? Wow. Anyhow, there was a choice of three e-stores to order from. One offers just the CD, another a CD and a discount t-shirt and the last an `}<em parentName="p">{`autographed`}</em>{` CD.`}</p>
    <p>{`Naturally I wanted the autographed one. But what's this? They don't ship to Slovenia even though they ship to other parts of the EU? Bloody bastards!`}</p>
    <p>{`Eventually I managed to order to a proxy in the UK who's then going to send it to me. Terribly complex and uselessly convoluted and for what, because an e-store is stupid.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      